"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LazyBackgroundImage", {
  enumerable: true,
  get: function () {
    return _lazyBackgroundImage.default;
  }
});
Object.defineProperty(exports, "LazyImage", {
  enumerable: true,
  get: function () {
    return _lazyImage.default;
  }
});
Object.defineProperty(exports, "LazyPicture", {
  enumerable: true,
  get: function () {
    return _lazyPicture.default;
  }
});
Object.defineProperty(exports, "imgPropShape", {
  enumerable: true,
  get: function () {
    return _lazyImage.imgPropShape;
  }
});
Object.defineProperty(exports, "loadingOptions", {
  enumerable: true,
  get: function () {
    return _useImageLoading.loadingOptions;
  }
});
var _lazyImage = _interopRequireWildcard(require("./lazy-image.js"));
var _lazyBackgroundImage = _interopRequireDefault(require("./lazy-background-image.js"));
var _lazyPicture = _interopRequireDefault(require("./lazy-picture.js"));
var _useImageLoading = require("../hooks/use-image-loading.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }